import * as React from "react";
import { Add as IconAdd, Close as IconClose } from "@material-ui/icons";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItem, Minus } from "../../models/menuItem";
import { Typography } from "@material-ui/core";

interface Props {
  menuItem: MenuItem;
  minus: Minus[];
  setMinus: React.Dispatch<React.SetStateAction<any[]>>;
}

const isEqualMinus = (a: Minus, b: Minus) =>
  a?.id === b?.id &&
  JSON.stringify(a?.meta ?? {}) === JSON.stringify(b?.meta ?? {});

const MenuItemMinus: React.FC<Props> = ({
  menuItem,
  minus,
  setMinus,
}) => {
  const toggle = (ingredient: any) => {
    setMinus((prev) => {
      const index = prev.findIndex((i) =>
        isEqualMinus(i, ingredient)
      );
      if (index > -1) {
        const copy = [...prev];
        copy.splice(index, 1);
        return copy;
      }
      return [...prev, ingredient];
    });
  };

  return (
    <>
      <div className="row" style={{marginTop: 15}}>
          <div className="col-12">
              <Typography variant="h5" gutterBottom className="menu-item-sub-header"
                          align="left">{LocalizerHelper.localized('minus_ingredients')}</Typography>
          </div>
      </div>
      <div className="row menu-item-minus-row">
          <div className="col-12">
              <div className="row menu-item-minus-row">
                <div className="col-12">
                  {(menuItem.minus ?? []).map((ingredient: Minus, index) => {
                    const selected = minus.findIndex((m) => isEqualMinus(m, ingredient)) > -1;
                    return (
                      <div
                        key={`minus-${ingredient.id}-${index}`}
                        className={`menu-item-minus-item ${
                          selected ? "selected" : ""
                        }`}
                        onClick={() => toggle(ingredient)}
                      >
                        <span>
                          {LocalizerHelper.localized(
                            ingredient,
                            ["title", "name"]
                          )}
                        </span>
                        {selected ? <IconAdd /> : <IconClose />}
                      </div>
                    );
                  })}
                </div>
              </div>
          </div>
      </div>
    </>
  );
};

export default MenuItemMinus;
